<template>
  <v-dialog
    :model-value="modelValue"
    max-width="480"
    persistent
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <v-card>
      <v-card-title
        class="text-h6 text-primary font-weight-bold px-5 pt-5 pb-1"
      >
        Import Schedule
      </v-card-title>
      <v-card-subtitle class="px-5 pb-3 text-body-2">
        Select a thermostat to copy its schedule from.
      </v-card-subtitle>

      <v-divider />

      <v-card-text class="pa-5" style="min-height: 160px">
        <v-progress-linear
          v-if="isLoading"
          indeterminate
          color="primary"
          class="mt-2"
        />

        <v-alert
          v-else-if="!thermostats.length"
          type="info"
          variant="tonal"
          class="mt-2"
        >
          No other thermostats with schedules are available.
        </v-alert>

        <v-radio-group
          v-else
          v-model="selectedThermostatId"
          hide-details
          color="primary"
        >
          <v-radio
            v-for="t in thermostats"
            :key="t.deviceId"
            :label="t.friendlyName"
            :value="t.deviceId"
          />
        </v-radio-group>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-btn variant="text" @click="$emit('update:modelValue', false)">
          Cancel
        </v-btn>
        <v-spacer />
        <v-btn
          variant="outlined"
          color="primary"
          :disabled="!selectedThermostatId || isLoading"
          @click="handleAction('edit')"
        >
          Import &amp; Edit
        </v-btn>
        <v-btn
          color="primary"
          :disabled="!selectedThermostatId || isLoading"
          @click="handleAction('save')"
        >
          Import &amp; Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/Core.Service.Domain/Controls/Thermostats/API';

export default {
  name: 'ImportScheduleDialog',

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    currentThermostatId: {
      type: Number,
      required: true,
    },
    siteId: {
      type: Number,
      default: null,
    },
  },

  emits: ['update:modelValue', 'import'],

  data() {
    return {
      isLoading: false,
      thermostats: [],
      selectedThermostatId: null,
    };
  },

  watch: {
    modelValue(val) {
      if (val) {
        this.selectedThermostatId = null;
        this.loadThermostats();
      }
    },
  },

  methods: {
    async loadThermostats() {
      // No site means no list to fetch — /thermostats/sites/undefined would 404.
      if (!this.siteId) {
        this.thermostats = [];
        return;
      }

      this.isLoading = true;
      try {
        const rows = await API.getThermostatsBySite(this.siteId);
        this.thermostats = (Array.isArray(rows) ? rows : []).filter(
          (t) => t.hasSchedule && t.deviceId !== this.currentThermostatId
        );
      } catch (error) {
        console.error('Error loading thermostats for import:', error);
        this.thermostats = [];
      } finally {
        this.isLoading = false;
      }
    },

    handleAction(action) {
      this.$emit('import', {
        thermostatId: this.selectedThermostatId,
        action,
      });
      this.$emit('update:modelValue', false);
    },
  },
};
</script>
